import { Box, Stack, Text } from '@mantine/core';
import React from 'react';

interface PageTitleProps {
  title: string;
  description?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, description }) => {
  return (
    <Stack>
      <Text size='xl' fw={700}>
        {title}
      </Text>
      <Box maw={570} mt={-10}>
        <Text c='dimmed'>{description}</Text>
      </Box>
    </Stack>
  );
};

export default PageTitle;
